import * as Sentry from '@sentry/react';
import { useSession } from '@descope/react-sdk';
import { Descope } from '@descope/react-sdk/flows';
import { Box } from '@mui/material';
import { Spinner } from '../../components/design/Spinner';
import { useCallback, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { DescopeErrorBoundary } from '../../contexts/descope-auth/DescopeErrorBoundary';

export function McpConsentPage() {
  const { isAuthenticated, isSessionLoading } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const flowId = searchParams.get('flow') ?? 'inbound-apps-user-consent';

  const handleError = useCallback((e: CustomEvent) => {
    Sentry.captureMessage('Descope consent flow error', {
      level: 'warning',
      extra: { detail: e.detail, component: 'McpConsentPage', flowId },
    });
  }, [flowId]);

  useEffect(() => {
    if (isSessionLoading) return;

    if (!isAuthenticated) {
      const loginUrl = new URL('/login', window.location.origin);
      loginUrl.searchParams.set('returnTo', `${location.pathname}${location.search}`);
      navigate(`${loginUrl.pathname}${loginUrl.search}`, { replace: true });
    }
  }, [isAuthenticated, isSessionLoading, navigate, location]);

  if (isSessionLoading || !isAuthenticated) {
    return <Spinner centerPage />;
  }

  return (
    <DescopeErrorBoundary>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Descope
          flowId={flowId}
          onError={handleError}
        />
      </Box>
    </DescopeErrorBoundary>
  );
}
